import React from 'react'

const FollowButton = ({Value,Action}) => {
  return (
    <button style={{
        border:"none",
        outline:"none",
        backgroundColor:"#104880",
        color: "white",
        padding:"10px 20px",
        borderRadius:"3px",
        cursor:"pointer"
    }} onClick={Action}>{Value}</button>
  )
}

export default FollowButton
